import {defineDimension, createBooleanMap} from '@webflow-platform/abilities';
import {
  DESIGNER_SITE_MODES,
  type DesignerSiteMode,
} from '@packages/systems/design-system/constants/DesignerUI';

export type SiteModesConfig = Partial<Record<DesignerSiteMode, boolean>>;
export type SiteModesStores = {
  DesignerStore?: {siteMode?: DesignerSiteMode};
};

export const siteModesDimension = defineDimension<
  SiteModesConfig,
  SiteModesStores
>()({
  key: 'siteModes',
  isValid(state, config) {
    // Use `in` before reading: partial DesignerStores proxies from
    // `createPartialDesignerStoreForTest` throw on missing keys even with `?.`.
    const currentSiteMode =
      'DesignerStore' in state ? state.DesignerStore?.siteMode : undefined;

    return currentSiteMode ? Boolean(config[currentSiteMode]) : true;
  },
  fragments: {
    inSiteModes: (...modes: DesignerSiteMode[]) =>
      createBooleanMap(modes, true),
  },
  testMatrix(addAxis) {
    addAxis((addCase) => {
      for (const siteMode of Object.values(DESIGNER_SITE_MODES)) {
        addCase({
          label: `siteMode === '${siteMode}'`,
          state: {DesignerStore: {siteMode}},
        });
      }
    });
  },
});

export const {inSiteModes} = siteModesDimension.fragments;
